// Global JavaScript for Xan Cycling

console.log('Xan Cycling theme loaded');

// Mobile menu toggle
document.addEventListener('DOMContentLoaded', function() {
  const menuToggle = document.querySelector('.mobile-menu-toggle');
  const mobileMenu = document.querySelector('.mobile-menu');
  
  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', function() {
      mobileMenu.classList.toggle('active');
      menuToggle.classList.toggle('active');
      document.body.classList.toggle('menu-open');
    });
  }
});

// Parallax effect for hero
window.addEventListener('scroll', function() {
  const parallaxElements = document.querySelectorAll('[data-parallax]');
  
  parallaxElements.forEach(function(element) {
    const scrolled = window.pageYOffset;
    const rate = scrolled * 0.5;
    element.style.transform = 'translate3d(0, ' + rate + 'px, 0)';
  });
});
